const RegionalTrucking = () => {
  return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-12.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem] ">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5  ">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
            Regional Trucking (TIR)
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Although Pakistan has been promoting its geographically strategic location for 
              decades it has only been recently that affirmative measures were taken to capitalise 
              on its key location at a global scale which would not only benefit the country itself 
              but also utilise the tremendous potential in Pakistan's services sector and manpower capabilities. 
              To achieve that, UN TIR Convention overseen by the International Road Transport Union (IRU) was implemented
              which is a tried and tested system and has already been in effect internationally.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem] mb-[1.5rem]">
              TCS, Pakistan’s first registered TIR authorised operator, and the pioneer of TIR operations from Pakistan
              to Uzbekistan is also approved by the government of Pakistan and USAID.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>

    </div>
  );
};

export default RegionalTrucking;
